import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: ${props => props.theme.unisystem.placeholder.background};
  color: ${props => props.theme.unisystem.placeholder.text};

  .logo {
    position: absolute;
    top: 12px;
    right: 12px;
  }
`;

export const Title = styled.span`
  font-family: 'IntervalNextMed', sans-serif;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(24)};
  margin-top: ${props => props.theme.space(3)};
  text-align: center;
`;

export const Subtitle = styled.span`
  font-family: 'IntervalNextBook', sans-serif;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(24)};
  text-align: center;
`;
